import React, { useEffect, useRef, useState } from "react";

import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  Button,
  Tooltip,
  MenuItem,
  InputBase,
  Autocomplete,
  Grid,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Badge,
  Popper,
  Divider,
  InputAdornment,
} from "@mui/material";

import { blue } from "@mui/material/colors";
import CallIcon from "@mui/icons-material/Call";
import AppsIcon from "@mui/icons-material/Apps";
import axiosInstance from "configs/axiosConfig";
import Person from "@mui/icons-material/Person";
import InfoIcon from "@mui/icons-material/Info";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import CategoryIcon from "@mui/icons-material/Category";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";

import ShoppingCart from "@mui/icons-material/ShoppingCart";
import {
  APIRouteConstants,
  authRouteConstants,
} from "constants/routeConstants";
import {
  setAllCategoryList,
  updateCartCount,
  updateWebsiteDetail,
} from "utils/website";
import { styled, alpha } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";

import _ from "lodash";
import SecondaryAppBar from "containers/SecondaryAppBar";
import SecondaryAppBar1 from "containers/SecondaryAppBar/index1";
import { useModal } from "utils/SignupContext";
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBaseMobile = styled(TextField)(({ theme }) => ({
  backgroundColor: "transparent",
  color: "inherit",
  display: "flex",
  width: "150px",
  padding: theme.spacing(0, 1, 0, 0),
  // paddingLeft: `calc(1em + ${theme.spacing(4)})`,

  "& .MuiInputBase-root": {
    transition: theme.transitions.create("width"),
    width: "100%",
    color: "white",
  },
  "& .MuiAutocomplete-endAdornment": {
    // display: 'none',
    border: "none",
    "& .MuiAutocomplete-popupIndicator": {
      color: "white",
    },
    "& .MuiAutocomplete-clearIndicator": {
      color: "white",
    },
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent", // Remove outline color when focused
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent", // Remove outline color on hover
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent", // Remove default outline color
    },
  },
}));

const StyledInputBase = styled(TextField)(({ theme }) => ({
  backgroundColor: "transparent",
  color: "inherit",
  display: "flex",
  padding: theme.spacing(0, 1, 0, 0),
  paddingLeft: `calc(1em + ${theme.spacing(4)})`,

  "& .MuiInputBase-root": {
    transition: theme.transitions.create("width"),
    width: "100%",
    color: "white",
  },
  "& .MuiAutocomplete-endAdornment": {
    // display: 'none',
    border: "none",
    "& .MuiAutocomplete-popupIndicator": {
      color: "white",
    },
    "& .MuiAutocomplete-clearIndicator": {
      color: "white",
    },
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent", // Remove outline color when focused
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent", // Remove outline color on hover
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent", // Remove default outline color
    },
  },
}));
function SearchAppBar({
  pages = [],
  settings = [],
  showToggleMenu,
  appTitle = "",
  logo,
  iconItems = [],
  user = null,
  searchProductList,
  productList,
  handleOpenAuthDialog,
}) {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [showSearch, setShowSearch] = useState(false);

  const { isOpen, openModal, closeModal } = useModal();
  const [cartCount, setCartCount] = useState();
  const navigate = useNavigate();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleSearch = () => {
    setShowSearch(!showSearch);
  };

  const handleOpenCategory = (event) => {
    setAnchorElCategory(event.currentTarget);
  };

  const handleCloseCategory = () => {
    setAnchorElCategory(null);
  };

  const navItems = [
    {
      title: "About",
      icon: <InfoIcon />,
      path: "/about",
    },
    {
      title: "Categories",
      icon: <CategoryIcon />,
      handleClick: handleOpenCategory,
      isDropdown: true,
      isMobileView: false,
      path: "/products",
    },
    {
      title: "Shop",
      icon: <ShoppingBagIcon />,
      path: "/products",
    },
  ];

  const [loader, setLoader] = useState(false);
  const webDetails = useSelector((state) => state.webDetails);
  const colors = {
    header_bg: webDetails?.websiteInfo?.header_bg
      ? webDetails?.websiteInfo?.header_bg
      : "#000",
    header_text: webDetails?.websiteInfo?.header_text
      ? webDetails?.websiteInfo?.header_text
      : "#fff",
  };
  const { allCategories, websiteInfo, refreshCart } = webDetails;
  const [filteredCategories, setFilteredCategory] = useState({
    categories: [],
    type: "nested",
  });
  const [anchorElCategory, setAnchorElCategory] = useState(null);
  const [searchStr, setSearchStr] = useState("");
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [openmenu, setmenuOpen] = useState(false);
  const filterCategory = (categories) => {
    let _categories = [];
    let _filteredCategories = [];
    let categoryTypeSimple = true;
    for (let category of categories) {
      if (!category.parent) {
        _categories.push(category);
      }
    }
    for (let category of _categories) {
      let list = _.filter(categories, { parent: category.id });
      if (list.length > 0) categoryTypeSimple = false;
      _filteredCategories.push({
        ...category,
        child: list,
      });
    }

    setFilteredCategory({
      categories: _filteredCategories,
      type: categoryTypeSimple ? "simple" : "nested",
    });
  };

  const getCategoryList = async () => {
    setLoader(true);
    let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.ALL_CATEGORY);
    let { data, response } = res;

    if (data) {
      setAllCategoryList(data);
    }
    setLoader(false);
  };
  useEffect(() => {
    if (!allCategories.length) getCategoryList();
    else {
      filterCategory(allCategories);
    }
  }, []);

  useEffect(() => {
    if (inputValue) searchProductList(inputValue, setSearchLoading);
    else searchProductList(null, setSearchLoading);
  }, [inputValue]);

  const rightNavItems = [
    {
      title: "Contact Us",
      icon: <CallIcon />,
      path: "/contact",
    },
  ];

  const userSettings = [
    {
      title: "My Account",
      icon: <AccountCircle />,
      path: "/user-setting",
    },
    {
      title: "My Order",
      icon: <AppsIcon />,
      path: "/order-history",
    },
    {
      title: "Logout",
      icon: <LogoutIcon />,
      path: authRouteConstants.LOGOUT,
    },
  ];
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);
  const [underline, setUnderline] = useState("transparent");

  useEffect(() => {
    setUnderline("#fff");
  }, []);

  const CustomPopper = styled(Popper)(({ theme }) => ({
    width: "100% !important",
    padding: "10px",
    // margin:"10px",
    margin: "auto",
    minWidth: "150px !important",
  }));

  return (
    <AppBar
      position="fixed"
      sx={{
        p: 0,
        background: colors.header_bg,
        // boxShadow: "none", // 👈 force remove
        borderBottom: "none",
      }}
      className="search-navbar"
    >
      <Container maxWidth="lg" disableGutters>
        <Toolbar
          disableGutters
          sx={{
            maxWidth: "1300px",
            width: "100%",
            margin: "0 auto",

            height: "72px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <SecondaryAppBar1
              navItems={navItems}
              colors={colors}
              rightNavItems={rightNavItems}
              anchor="left"
              settings={userSettings}
              user={user}
              handleOpenAuthDialog={() => handleOpenAuthDialog(true)}
              iconItems={[
                {
                  title: "Cart",
                  icon: cartCount ? (
                    <Badge
                      badgeContent={cartCount}
                      showZero={!cartCount}
                      color="info"
                    >
                      <Typography fontSize="xl">
                        <ShoppingCart
                          sx={{ color: blue[200], fontSize: "1rem" }}
                        />
                      </Typography>
                    </Badge>
                  ) : (
                    <ShoppingCart sx={{ color: blue[200], fontSize: "1rem" }} />
                  ),
                  path: "/cart",
                  helpText: "Open Cart",
                  isMobileView: true,
                  isAuth: false,
                },
              ]}
            />
            <Box
              // className="logo-wrapper"
              sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
              onClick={() => {
                if (webDetails?.websiteInfo?.store_name === "The Vet Store") {
                  window.open("https://thevetstore.co.za/", "_blank");
                }
                navigate("/");
              }}
            >
              <img
                src={logo || require("../../../assets/images/logo.png")}
                alt="logo"
                style={{ height: 50 }}
              />
            </Box>
            <Typography
              variant="h6"
              noWrap
              component="span"
              onClick={() => {
                if (webDetails?.websiteInfo?.store_name === "The Vet Store") {
                  window.open("https://thevetstore.co.za/", "_blank");
                } else {
                  navigate("/");
                }
              }}
              sx={{
                ml: 0,
                display: { xs: "", md: "flex" },
                fontSize: {
                  xs: "0.9rem", // 📱 mobile
                  sm: "1rem", // tablet
                  md: "1.05rem", // small desktop
                  lg: "1.1rem", // desktop
                },
                fontWeight: 600,
                letterSpacing: "0.04em",
                color: colors.header_text,
                cursor: "pointer",
                textTransform: "uppercase",
              }}
            >
              {appTitle}
            </Typography>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "right",
              gap: 3,
            }}
          >
            <Box
              sx={{
                display: { xs: "none", md: "none", lg: "flex" },
                gap: "20px",
              }}
            >
              <Link
                style={{
                  textDecoration: isHovered1 ? "underline" : "none",
                  textDecorationColor: isHovered1
                    ? colors.header_text
                    : "transparent", // Underline color on hover
                  color: colors.header_text,
                  fontSize: "0.75rem",
                  fontWeight: "550",
                  transition: "text-decoration-color 0.3s",
                  textTransform: "uppercase",
                  textDecoration: "none",
                  // Smooth transition for underline color
                }}
                onMouseEnter={() => setIsHovered1(true)}
                onMouseLeave={() => setIsHovered1(false)}
                to={"/about"}
              >
                About us
              </Link>
              <Link
                style={{
                  textDecoration: isHovered ? "underline" : "none",
                  textDecorationColor: isHovered
                    ? colors.header_text
                    : "transparent", // Underline color on hover
                  color: colors.header_text,
                  fontSize: "0.75rem",
                  fontWeight: "550",
                  transition: "text-decoration-color 0.3s", // Smooth transition for underline color
                  textTransform: "uppercase",
                  textDecoration: "none",
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                to="/products"
              >
                Shop
              </Link>
            </Box>
            {/* <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }} /> */}

            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                width: "480px", // ⬇️ reduced width
                height: "40px", // ⬇️ reduced height
                borderRadius: "999px",
                backgroundColor: "transparent",
                border: "1px solid rgba(0,0,0,0.25)",
                boxShadow: `0.5px 0.1px 0.1px 0.01px ${colors.header_text}`,
                alignItems: "center",
                px: 2,
                position: "relative",
              }}
            >
              <Autocomplete
                id="product-search"
                options={productList}
                getOptionLabel={(option) =>
                  typeof option === "string" ? option : option.name || ""
                }
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                filterOptions={(x) => x}
                autoComplete
                includeInputInList
                filterSelectedOptions
                openOnFocus
                value={value}
                size="small"
                loading={searchLoading}
                onChange={(event, newValue) => {
                  if (!newValue) return;

                  setValue(newValue);
                  const productId =
                    Array.isArray(newValue?.variants) &&
                    newValue?.variants[0]?.id;

                  if (productId) navigate(`/product/${productId}`);
                }}
                onInputChange={(event, newInputValue) =>
                  setInputValue(newInputValue)
                }
                sx={{
                  width: "100%",

                  /* remove dropdown arrow */
                  "& .MuiAutocomplete-popupIndicator": {
                    display: "none",
                  },

                  "& .MuiInputBase-root": {
                    padding: 0,
                    height: "40px",
                    borderRadius: "999px",
                    color: "#fff",
                    backgroundColor: "transparent",
                  },

                  "& .MuiInputBase-input": {
                    fontSize: "0.8rem", // ⬇️ reduced text size
                    color: colors.header_text,
                    padding: "8px 8px 8px 0px",
                  },

                  "& .MuiInputBase-input::placeholder": {
                    color: colors.header_text,
                    fontSize: "0.75rem", // ⬇️ smaller placeholder
                    opacity: 1,
                  },

                  "& fieldset": {
                    border: "none",
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search products, stores or brands"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <>
                          <SearchIcon
                            sx={{
                              color: colors.header_text,
                              fontSize: 20,
                              mr: 1,
                            }}
                          />
                          {params.InputProps.startAdornment}
                        </>
                      ),
                      endAdornment: searchLoading ? (
                        <CircularProgress size={16} />
                      ) : null,
                    }}
                  />
                )}
                PaperComponent={({ children }) => (
                  <Box
                    sx={{
                      width: "100%",
                      backgroundColor: "#fff",
                      boxShadow: "0px 8px 24px rgba(0,0,0,0.2)", // ⬇️ softer dropdown shadow
                      borderRadius: "12px",
                      overflow: "hidden",
                      mt: 1,
                    }}
                  >
                    {children}
                  </Box>
                )}
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        py: 1,
                        px: 2,
                        width: "100%",
                      }}
                    >
                      <img
                        src={option.product_image}
                        alt={option.name}
                        style={{
                          width: 40, // ⬇️ slightly smaller image
                          height: 40,
                          objectFit: "cover",
                          borderRadius: "6px",
                        }}
                      />

                      <Box sx={{ flexGrow: 1 }}>
                        <Typography
                          sx={{ fontSize: "0.85rem", fontWeight: 600 }}
                        >
                          {option.name}
                        </Typography>
                        <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
                          {option.category_name || ""}
                        </Typography>
                      </Box>

                      <Typography sx={{ fontSize: "0.8rem", fontWeight: 600 }}>
                        {option.price ? `R ${option.price}` : ""}
                      </Typography>
                    </Box>
                  </li>
                )}
              />
            </Box>

            {/* Display Mobile */}
            {showToggleMenu && (
              <Box
                sx={{
                  flexGrow: 1,
                  display: { xs: "flex", sm: "flex", md: "none" },
                }}
              >
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  // keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: "block", sm: "block", md: "none" },
                  }}
                >
                  {pages.map((page) => (
                    <MenuItem key={page} onClick={handleCloseNavMenu}>
                      <Typography textAlign="center">{page}</Typography>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            )}

            {/* {!showSearch && (
                <Typography
                  variant="span"
                  className="logo-title"
                  noWrap
                  component="a"
                  onClick={() => navigate("/")}
                  sx={{
                    mr: 2,
                    display: { xs: "flex", sm: "flex", md: "none" },
                    flexGrow: 1,
                    fontFamily: "monospace",
                    fontWeight: 700,

                    letterSpacing: "0.1rem",
                    color: colors.header_text,
                    textDecoration: "none",
                    fontFamily: "'Mulish', sans-serif",
                    fontSize: {
                      xs: "1rem !important",
                      sm: "1.5rem !important",
                    },
                  }}
                >
                  {appTitle}
                </Typography>
              )} */}

            {/* {!showSearch && (
                <IconButton
                  sx={{ display: { xs: "flex", md: "none" }, mr: 1 }}
                  aria-label="search"
                  onClick={handleSearch}
                  color="inherit"
                >
                  <SearchIcon style={{ color: colors.header_text }} />
                </IconButton>
              )} */}

            {showSearch && (
              <Search
                sx={{
                  display: { xs: "flex", md: "none" },
                  mr: 0,
                  border: `1px solid ${colors.header_text}`,
                }}
                className="search-bar"
              >
                {/* <SearchIconWrapper className="search-icon">
                  <SearchIcon />
                </SearchIconWrapper> */}
                <Autocomplete
                  id="product-search"
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.name
                  }
                  PopperComponent={CustomPopper}
                  filterOptions={(x) => x}
                  options={productList}
                  autoComplete
                  includeInputInList
                  filterSelectedOptions
                  value={value}
                  size="small"
                  loading={searchLoading}
                  noOptionsText="Search ... "
                  sx={{
                    "& .MuiInputBase-input::placeholder": {
                      fontSize: "1rem",
                      color: colors.header_text,
                    },
                    "& .MuiInputBase-input": {
                      fontSize: "1rem",
                      color: colors.header_text,
                    },
                  }}
                  onBlur={() => {
                    handleSearch();
                  }}
                  onChange={(event, newValue) => {
                    setOptions(newValue ? [newValue, ...options] : options);
                    setValue(newValue);
                    handleSearch();
                  }}
                  onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                  }}
                  renderInput={(params) => (
                    <StyledInputBaseMobile
                      {...params}
                      fullWidth
                      autoFocus={true}
                      sx={{
                        "& .MuiInputBase-input::placeholder": {
                          fontSize: "1rem",
                          color: colors.header_text,
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "1rem",
                          color: colors.header_text,
                        },
                      }}
                      placeholder="Search ..."
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: null, // 👈 removes loading spinner, dropdown icon, etc.
                        startAdornment: null,
                        // endAdornment: (
                        //   <>
                        //     {searchLoading ? (
                        //       <CircularProgress color="inherit" size={20} />
                        //     ) : null}
                        //     {params.InputProps.endAdornment}
                        //   </>
                        // ),
                      }}
                    />
                  )}
                  renderOption={(props, option) => {
                    return (
                      <li {...props} className="auto-search-item-wrapper">
                        <Grid
                          onClick={() => {
                            navigate(`/product/${option.id}`);
                          }}
                          container
                          alignItems="center"
                          className="auto-search-item-container"
                        >
                          <Grid
                            item
                            sx={{ display: "flex", width: "55px" }}
                            className="auto-search-item-img"
                          >
                            <img src={option.product_image} alt={option.name} />
                          </Grid>
                          <Grid
                            item
                            sx={{
                              width: "calc(100% - 55px)",
                              wordWrap: "break-word",
                            }}
                            className="auto-search-item-detail"
                          >
                            <Typography variant="body2" color="text.secondary">
                              {/* <b>{option.category_name}</b>{" - "}{option.name} */}
                              <b>{option.name}</b>
                              {" in "}
                              {option.category_name}
                            </Typography>
                          </Grid>
                        </Grid>
                      </li>
                    );
                  }}
                />
              </Search>
            )}
            <Box
              sx={{
                flexGrow: 0,
                display: "flex",
                alignItems: "baseline",
              }}
            >
              {iconItems.map((item, i) =>
                (item.isAuth && user) || !item.isAuth ? (
                  <Tooltip title={item.helptext}>
                    <Box
                      sx={{
                        display: {
                          xs: item.isMobileView ? "flex" : "none",
                          md: "flex",
                        },
                      }}
                    >
                      <IconButton
                        onClick={item.handleClick}
                        sx={{ p: 0, color: colors.header_text }}
                        className="icon-wrapper"
                      >
                        {item.icon}
                      </IconButton>
                    </Box>
                  </Tooltip>
                ) : (
                  ""
                ),
              )}
            </Box>
            <Box
              sx={{
                flexGrow: 0,
                display: "flex",
              }}
            >
              {!user ? (
                <Button
                  startIcon={<AccountCircle />}
                  sx={{
                    color: colors.header_text,

                    fontSize: "0.85rem",
                    fontWeight: "550",
                    textTransform: "none",

                    "&:hover": {
                      textDecoration: "underline",
                      textDecorationColor: colors.header_text, // Set the color of the underline
                      // textTransform: "uppercase",
                      textDecorationLine: "none",
                    },
                  }}
                  onClick={openModal}
                >
                  Login
                </Button>
              ) : (
                ""
              )}
            </Box>
            <Box
              sx={{
                flexGrow: 0,
                display: { xs: "none", sm: "none", md: "flex" },
              }}
            >
              {/* <Link
                style={{
                  textDecoration: "none",
                  color: "#fff",
                  fontSize: "0.7rem",
                  fontWeight: "500",
                  whiteSpace:"nowrap"
                }}
                sx={{
                  color: "#fff",
                  marginLeft: "1rem",
                  textDecoration: "none",
                }}
              >
                Contact us
              </Link> */}
            </Box>
          </Box>
        </Toolbar>
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            px: 2,
            pb: 1.5,
          }}
        >
          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              width: "480px", // ⬇️ reduced width
              height: "40px", // ⬇️ reduced height
              borderRadius: "999px",
              backgroundColor: "transparent",
              border: "1px solid rgba(0,0,0,0.25)",
              boxShadow: `0.5px 0.1px 0.1px 0.01px ${colors.header_text}`,
              alignItems: "center",
              px: 2,
              position: "relative",
            }}
          >
            <Autocomplete
              id="product-search"
              options={productList}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.name || ""
              }
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              filterOptions={(x) => x}
              autoComplete
              includeInputInList
              filterSelectedOptions
              openOnFocus
              value={value}
              size="small"
              loading={searchLoading}
              onChange={(event, newValue) => {
                if (!newValue) return;

                setValue(newValue);
                const productId =
                  Array.isArray(newValue?.variants) &&
                  newValue?.variants[0]?.id;

                if (productId) navigate(`/product/${productId}`);
              }}
              onInputChange={(event, newInputValue) =>
                setInputValue(newInputValue)
              }
              sx={{
                width: "100%",

                /* remove dropdown arrow */
                "& .MuiAutocomplete-popupIndicator": {
                  display: "none",
                },

                "& .MuiInputBase-root": {
                  padding: 0,
                  height: "40px",
                  borderRadius: "999px",
                  color: "#fff",
                  backgroundColor: "transparent",
                },

                "& .MuiInputBase-input": {
                  fontSize: "0.8rem", // ⬇️ reduced text size
                  color: colors.header_text,
                  padding: "8px 8px 8px 0px",
                },

                "& .MuiInputBase-input::placeholder": {
                  color: colors.header_text,
                  fontSize: "0.75rem", // ⬇️ smaller placeholder
                  opacity: 1,
                },

                "& fieldset": {
                  border: "none",
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search products, stores or brands"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <SearchIcon
                          sx={{
                            color: colors.header_text,
                            fontSize: 20,
                            mr: 1,
                          }}
                        />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                    endAdornment: searchLoading ? (
                      <CircularProgress size={16} />
                    ) : null,
                  }}
                />
              )}
              PaperComponent={({ children }) => (
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: "#fff",
                    boxShadow: "0px 8px 24px rgba(0,0,0,0.2)", // ⬇️ softer dropdown shadow
                    borderRadius: "12px",
                    overflow: "hidden",
                    mt: 1,
                  }}
                >
                  {children}
                </Box>
              )}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      py: 1,
                      px: 2,
                      width: "100%",
                    }}
                  >
                    <img
                      src={option.product_image}
                      alt={option.name}
                      style={{
                        width: 40, // ⬇️ slightly smaller image
                        height: 40,
                        objectFit: "cover",
                        borderRadius: "6px",
                      }}
                    />

                    <Box sx={{ flexGrow: 1 }}>
                      <Typography sx={{ fontSize: "0.85rem", fontWeight: 600 }}>
                        {option.name}
                      </Typography>
                      <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
                        {option.category_name || ""}
                      </Typography>
                    </Box>

                    <Typography sx={{ fontSize: "0.8rem", fontWeight: 600 }}>
                      {option.price ? `R ${option.price}` : ""}
                    </Typography>
                  </Box>
                </li>
              )}
            />
          </Box>
        </Box>
      </Container>
    </AppBar>
  );
}
export default SearchAppBar;
